import type { CustomTableColumn } from '@/components/Form/Table/CustomTable';
import type { AssistedAffiliationFilters, AssistedAffiliationStatus, SearchKey } from './types';

export const STATUS_LABELS: Record<AssistedAffiliationStatus, string> = {
  DRAFT: 'Borrador',
  IN_PROGRESS: 'En proceso',
  PENDING_INFORMATION: 'Información pendiente',
  COMMERCE_CREATED: 'Comercio creado',
  REQUEST_CANCELLED: 'Rechazado',
  CREATION_ERROR: 'Error de creación',
};

// Solo las solicitudes aún abiertas a captura admiten edición.
export const EDITABLE_STATUSES: AssistedAffiliationStatus[] = [
  'DRAFT',
  'PENDING_INFORMATION',
];

const dateFormatter = new Intl.DateTimeFormat('es-DO', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
});

export const formatCreatedAt = (value: string | number): string => {
  // `new Date(null)` y `new Date('')` no dan NaN, sino el Unix epoch, así que la ausencia de
  // valor se descarta aparte.
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return dateFormatter.format(date).replace(',', '').replace(/\u00A0/g, ' ');
};

// La celda de fecha viaja como epoch para que el orden por cabecera sea cronológico; `format`
// la convierte a texto al renderizar.
export const COLUMNS: CustomTableColumn[] = [
  { id: 'registryNumber', label: 'Registro #' },
  { id: 'createdAt', label: 'Fecha de creación', format: formatCreatedAt },
  { id: 'identification', label: 'Identificación' },
  { id: 'commercialName', label: 'Nombre Comercial' },
  { id: 'legalRepresentative', label: 'Representante legal' },
  { id: 'status', label: 'Estado' },
  { id: 'bhdExecutive', label: 'Ejecutivo BHD' },
  { id: 'commercialAssignee', label: 'Asignado comercial' },
  { id: 'actions', label: 'Acciones' },
];

export const SEARCH_KEY_LABELS: Record<SearchKey, string> = {
  identification: 'Identificación',
  commercialName: 'Nombre del comercio',
  legalRepresentative: 'Representante legal',
  bhdExecutive: 'Ejecutivo BHD',
  commercialAssignee: 'Asignación comercial',
};

export const DEFAULT_SEARCH_KEY: SearchKey = 'identification';

// Estado inicial de la bandeja y destino del botón "Limpiar filtros".
export const EMPTY_FILTERS: AssistedAffiliationFilters = {
  searchKey: DEFAULT_SEARCH_KEY,
  searchTerm: '',
  dateFrom: null,
  dateTo: null,
};

export const EMPTY_TABLE_MESSAGE = 'No hay registro(s)';

